import { Link } from "react-router-dom";
import { Zap, Mail, Phone, MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { CONTACT, NAV } from "../data/content";
import { useUI } from "../context/UIContext";

export const Footer = () => {
  const { openUpload } = useUI();
  return (
    <footer className="bg-blue-950 text-white" data-testid="main-footer">
      {/* Big CTA */}
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 pt-24 pb-16 border-b border-white/10">
        <div className="grid lg:grid-cols-2 gap-10 items-end">
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-blue-300 mb-6">
              Bereit für den Wechsel?
            </p>
            <h2 className="text-4xl sm:text-6xl font-heading font-semibold leading-[0.95] tracking-tight">
              Lassen Sie Ihre <br />
              Rechnung{" "}
              <span className="font-serif italic text-blue-300">kostenlos</span>{" "}
              prüfen.
            </h2>
          </div>
          <div className="flex flex-wrap gap-4 lg:justify-end">
            <button
              onClick={openUpload}
              data-testid="footer-upload-btn"
              className="rounded-full bg-blue-600 hover:bg-blue-500 text-white px-8 py-4 font-medium transition-colors duration-300 hover:-translate-y-1"
            >
              Rechnung hochladen
            </button>
            <a
              href={CONTACT.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-full border border-white/20 hover:bg-white/10 px-8 py-4 font-medium transition-colors inline-flex items-center gap-2"
              data-testid="footer-whatsapp-btn"
            >
              <MessageCircle className="h-4 w-4" /> WhatsApp
            </a>
          </div>
        </div>
      </div>

      {/* Links */}
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2 mb-5">
            <span className="h-8 w-8 rounded-full bg-blue-500 grid place-items-center">
              <Zap className="h-4 w-4 text-white" strokeWidth={2.5} />
            </span>
            <span className="font-heading font-semibold">Energie·Tarifberater</span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">
            Unabhängige Energieberatung für Strom & Gas. Persönlich, transparent und deutschlandweit.
          </p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-5">Navigation</p>
          <ul className="space-y-3">
            {NAV.slice(0, 6).map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-sm text-slate-300 hover:text-blue-300 transition-colors">
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-5">Mehr</p>
          <ul className="space-y-3">
            {NAV.slice(6).map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-sm text-slate-300 hover:text-blue-300 transition-colors">
                  {n.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/standorte" className="text-sm text-slate-300 hover:text-blue-300 transition-colors" data-testid="footer-standorte-link">
                Standorte
              </Link>
            </li>
            <li>
              <Link to="/branchen" className="text-sm text-slate-300 hover:text-blue-300 transition-colors" data-testid="footer-branchen-link">
                Branchen
              </Link>
            </li>
            <li>
              <Link to="/gewerbestrom" className="text-sm text-slate-300 hover:text-blue-300 transition-colors" data-testid="footer-gewerbestrom-link">
                Gewerbestrom
              </Link>
            </li>
            <li>
              <Link to="/tarife/stromanbieter-vergleichen" className="text-sm text-slate-300 hover:text-blue-300 transition-colors" data-testid="footer-anbieter-link">
                Anbieter vergleichen
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-5">Kontakt</p>
          <ul className="space-y-3 text-sm text-slate-300">
            <li><a href={CONTACT.phoneHref} className="flex items-center gap-2 hover:text-blue-300"><Phone className="h-4 w-4" /> {CONTACT.phone}</a></li>
            <li><a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-emerald-400 hover:text-emerald-300"><MessageCircle className="h-4 w-4" /> WhatsApp</a></li>
            <li><a href={CONTACT.emailHref} className="flex items-center gap-2 hover:text-blue-300"><Mail className="h-4 w-4" /> {CONTACT.email}</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 sm:px-10 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} {CONTACT.company}. Alle Rechte vorbehalten.</p>
          <div className="flex items-center gap-5">
            <Link to="/impressum" className="hover:text-blue-300 transition-colors" data-testid="footer-impressum-link">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-blue-300 transition-colors" data-testid="footer-datenschutz-link">Datenschutz</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
